export interface PagePreview {
  id: string
  volume: string
  title: string
  image: string
  alt: string
}

/** Pagine reali dei volumi mostrate nella sezione "Guarda dentro". */
export const previews: PagePreview[] = [
  {
    id: 'posturale',
    volume: 'Yoga Terapeutico & Posturale',
    title: 'Lezione 05 — Dopo molte ore seduti',
    image:
      'https://cdn.magicpatterns.com/uploads/f8npqrYxgohDDNHcZVvGKC/Volume-4-Yoga-Terapeutico-and-Posturale-15.webp',
    alt: 'Pagina del volume Yoga Terapeutico & Posturale: Lezione 05 "Dopo molte ore seduti", 45 minuti, scaletta a tempi e 6 foto delle posizioni con sedia e muro.',
  },
  {
    id: 'hatha',
    volume: 'Hatha & Allineamento',
    title: 'Lezione 06 — Postura focus: sedia',
    image:
      'https://cdn.magicpatterns.com/uploads/j5cfakCu85cDwGu9aipEbB/Hatha__Allineamento-18.webp',
    alt: 'Pagina del volume Hatha & Allineamento: guida di conduzione della posizione della sedia con ingresso, conduzione, uscita, varianti e foto passo a passo.',
  },
  {
    id: 'yin',
    volume: 'Yin & Yoga Rigenerativo',
    title: 'Lezione 03 — Apertura delle braccia sulla sedia',
    image:
      'https://cdn.magicpatterns.com/uploads/uGq5SXxnKe8vKV6aGz4rDQ/Yin-and-Yoga-Reginerativo-12.webp',
    alt: 'Pagina del volume Yin & Yoga Rigenerativo: apertura delle braccia sulla sedia in 3 passaggi, con varianti e frasi di apertura e chiusura.',
  },
  {
    id: 'pranayama',
    volume: 'Pranayama & Meditazione',
    title: 'Pratica focus — Notare un punto di contatto',
    image:
      'https://cdn.magicpatterns.com/uploads/okPEfHrR7FZoWGTKq5WdHi/Volume-5-Pranayama-and-Meditazione-20.webp',
    alt: 'Pagina del volume Pranayama & Meditazione: pratica guidata con istruzioni, guione pronto con pause, varianti e chiusura.',
  },
  {
    id: 'emergenza',
    volume: "Classi d'Emergenza Pronte",
    title: 'Lezione 11 — Poco spazio, movimento semplice',
    image:
      'https://cdn.magicpatterns.com/uploads/bH7ixptMsMYRhUCnBC37rr/Volume-6-Classi-Demergenza-Pronte-27.webp',
    alt: "Pagina del volume Classi d'Emergenza Pronte: lezione di 30 minuti per sale piccole, in 6 fasi con tempi e foto.",
  },
]
